import axios from "axios";
import CryptoJS from "crypto-js";
import apiUrl from "../../../../constants";

export default {
  name: "BulkAutoNoInfoUpload",

  data() {
    return {
      selectedFile: null,
      uploading: false,
      message: "",
      Intimation: "",
      sampleCsvUrl: "/sample-files/noinfo-sample.csv"
    };
  },

  async mounted() {
    this.userDataKey = localStorage.getItem("userUniqueKey");

    let encrypted = localStorage.getItem("lmaccessuserdata");
    let bytes = CryptoJS.AES.decrypt(encrypted, this.userDataKey);
    let user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    this.localuserid = user.userid;
    this.localusermailid = user.email;
    this.localhubdetails = user.hubdetails[0];
  },

  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      this.message = "";

      if (!file) return (this.selectedFile = null);

      if (!file.name.endsWith(".csv")) {
        this.$alertify.error("Only CSV files are allowed.");
        this.selectedFile = null;
        this.$refs.fileInput.value = null;
        return;
      }

      this.selectedFile = file;
    },

    async uploadCsv() {
      if (!this.selectedFile) return this.$alertify.error("Upload a CSV file.");
      if (!this.Intimation.trim())
        return this.$alertify.error("Please enter Intimation For.");

      this.uploading = true;
      this.message = "";

      try {
        const formData = new FormData();
        formData.append("file", this.selectedFile);
        formData.append("CreatedBy", this.localusermailid);
        formData.append("HubId", this.localhubdetails);
        formData.append("IntimationFor", this.Intimation);

        const response = await axios.post(
          apiUrl.api_url + "bulkautonotify/uploadcsv",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        const { code, message } = response.data;

        if (code === 200) {

          this.$alertify.success(message);
        }
        else { 
          this.$alertify.error(message); 
        }

        this.message = message;
        this.resetForm()
      } catch (err) {
        console.error("Upload error:", err);

        const msg =
          err.response.data.message ||
          err.message ||
          "Unexpected error occurred";

        this.$alertify.error(msg);
        this.message = msg;
      } finally {
        this.uploading = false;
      }
    },
    resetForm() {
      this.selectedFile = null;
      this.Intimation = "";
      this.message = "";

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }

      this.$validator.reset();
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/LOST/BulkAutoNotify/BulkAutoNotify.component.js